import type { ParsedQs } from 'qs';

import { getQueryStringSingleValue } from '#src/app/shared/utils/query';

/**
 * Returns token by looking at query param
 *
 * Token being returned is prefixed with its type (cs_<token>) when applicable
 *
 * If prefix parameter is present, it is added to the name of the query param (e.g. `cs_<prefix>_tk`, `<prefix>_tk`)
 *
 * Current list of cs tokens with prefixes:
 * - cs_tk: comms token for identifying / authenticating a user
 * - cs_auth_tk: one time password reset token. Ref: https://github.com/change/corgi/blob/main/apps/middle-end/src/app/middlewares/token_auto_login.ts#L18
 * - cs_fdbk_tk: user feedback token. Ref: https://github.com/change/corgi/blob/main/apps/middle-end/src/app/routes/feedback/index.ts#L14
 * - cs_sig_revoke_tk: revoke signature token. Ref: https://github.com/change/corgi/blob/main/apps/front-end/src/app/pages/accountSettings/revokeSignature/pageContext/hook.ts#L21
 * - cs_unsub_tk: unsubscribe from comms token. Ref: https://github.com/change/corgi/blob/main/apps/front-end/src/app/pages/accountSettings/unsubscribeEmail/pageContext/hook.ts#L34
 */
export function getQueryParamToken(query: ParsedQs, prefix?: string): string | undefined {
	const prefixWithUnderscore = prefix ? `${prefix}_` : '';
	const csToken = getQueryStringSingleValue(query, `cs_${prefixWithUnderscore}tk`);
	const monorailToken = getQueryStringSingleValue(query, `${prefixWithUnderscore}tk`);

	if (csToken) return `cs_${csToken}`;
	return monorailToken;
}
